'use client';

import dynamic from 'next/dynamic';

// Dynamically import the Footer component with no SSR for lazy loading
const Footer = dynamic(() => import('./Footer'), {
  ssr: false,
  loading: () => <div style={{ 
    height: '400px', 
    backgroundColor: '#f5f5f5', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    marginTop: 'var(--s-12)',
    padding: '0 var(--s-12)'
  }}>
    <div style={{ color: '#666', fontSize: '14px' }}>Loading footer...</div>
  </div>
});

const ClientFooter: React.FC = () => {
  return <Footer />;
};

export default ClientFooter; 